import type { TableKeeper } from "../common/computation-model/table-keeper";
import type { TableKeeperStore } from "../common/computation-model/table-keeper-store";
import type { TableName } from "../common/database-strings";
import { areTableNamesEqual } from "../common/database-strings";
import { ArrayMap } from "../support/array-map";
import { SimpleTableKeeper } from "./table-keeper";

export class TableKeeperStoreImpl<T extends TableKeeper> implements TableKeeperStore<T> {
    private readonly _forTable = new ArrayMap<TableName, T>(areTableNamesEqual);
    private readonly _userSpecificForTable = new ArrayMap<TableName, TableKeeper>(areTableNamesEqual);

    constructor(
        private readonly _makeKeeper: (tn: TableName) => T,
        private readonly _withSeparateUserSpecificData: boolean
    ) {}

    public getTableKeeperForTable(tn: TableName): T {
        return this._forTable.getOrSet(tn, () => this._makeKeeper(tn));
    }

    public getUserSpecificTableKeeperForTable(tn: TableName): TableKeeper | undefined {
        if (!this._withSeparateUserSpecificData) return undefined;

        return this._userSpecificForTable.getOrSet(tn, () => new SimpleTableKeeper());
    }
}
